module.exports = __webpack_public_path__ + "079b834714bed8a2a943d5985cd8140c.svg";